import { render, staticRenderFns } from "./BusinessRibbonFeedback.vue?vue&type=template&id=7ed33d62&"
import script from "./BusinessRibbonFeedback.vue?vue&type=script&lang=js&"
export * from "./BusinessRibbonFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports